import {
  CONNECTION_DEFAULT_ORDERING,
  CONNECTION_DEFAULT_SORT_BY,
  CONNECTION_DEFAULT_SORT_DIRECTION,
  ConnectionRequestFilterState,
} from '../../app/components/ConnectionRequestsFilters';
import { useSearchParamsState } from '../../app/hooks/search-params';

export const useConnectionRequestsFilters = () => {
  const [specialties, setSpecialties] = useSearchParamsState('specialties', [], true);
  const [facility, setFacility] = useSearchParamsState<string[]>('facility', [], true);
  const [opportunity, setOpportunity] = useSearchParamsState<string[]>('opportunity', [], true);
  const [statusCategory, setStatusCategory] = useSearchParamsState('status_category', '');
  const [search, setSearch] = useSearchParamsState('search', '');
  const [sortBy, setSortBy] = useSearchParamsState('sort_by', CONNECTION_DEFAULT_SORT_BY);
  const [sortDirection, setSortDirection] = useSearchParamsState(
    'sort_direction',
    CONNECTION_DEFAULT_SORT_DIRECTION
  );
  const [ordering, setOrdering] = useSearchParamsState('ordering', CONNECTION_DEFAULT_ORDERING);

  const setFilters = (filters: ConnectionRequestFilterState) => {
    setSpecialties(filters.specialties);
    if (Array.isArray(filters.facility) && filters.facility.length > 0) {
      setFacility(filters.facility);
    } else {
      setFacility([]);
    }
    if (Array.isArray(filters.opportunity) && filters.opportunity.length > 0) {
      setOpportunity(filters.opportunity);
    } else {
      setOpportunity([]);
    }
    setStatusCategory(filters.statusCategory);
    setSearch(filters.search);
    setSortBy(filters.sortBy);
    setSortDirection(filters.sortDirection);
    setOrdering(filters.sortDirection === 'desc' ? `-${filters.sortBy}` : filters.sortBy);
  };

  return {
    filters: {
      specialties,
      ...(Array.isArray(facility) && facility.length > 0 ? { facility } : {}),
      ...(Array.isArray(opportunity) && opportunity.length > 0 ? { opportunity } : {}),
      statusCategory,
      search,
      sortBy,
      sortDirection,
      ordering,
    },
    setFilters,
  };
};
